import React from 'react';
import * as Ons from 'react-onsenui';

class PullHook extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {
            pullHook: 'initial'
        };

        this.handlePullHookChange = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad   = this.handlePullHookLoad.bind( this );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

        this.props.onChange( e );

    }

    handlePullHookLoad( e ) {

        this.props.onLoad( e );

    }

    render() {

        return (

            <Ons.PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad}>
                    {
                        this.state.pullHook === 'initial' ?

                            <div className="loading">
                                <Ons.Icon icon='fa-spinner' style={{ opacity: .5 }}></Ons.Icon>
                            </div>

                        : this.state.pullHook === 'preaction' ?

                            <div className="loading">
                                <Ons.Icon icon='fa-spinner'></Ons.Icon>
                            </div>

                        :

                            <div className="loading">
                                <Ons.Icon icon='fa-spinner' spin={true}></Ons.Icon>
                            </div>
                    }
                </Ons.PullHook>


        );

    }

}

export default PullHook;